// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1T69t"};


//////////////////
// WEBPACK FOOTER
// ./app/components/overlay/overlay.scss
// module id = 1386
// module chunks = 0